const login = {
    state: {
      toPath:'/studyRecordCount'
    },
    mutations: {
      setToPath(state,toPath){
         state.toPath = toPath
      },
      initializePath(state){
        state.toPath = '/studyRecordCount'
      }
    },
    actions: {
      setToPath(context,toPath){
        context.commit('setToPath',toPath)
      },
      initializePath(context,toPath){
        context.commit('initializePath',toPath)
      },
    }
}

export default login